import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sports-participation',
  templateUrl: './sports-participation.component.html',
  styleUrls: ['./sports-participation.component.css']
})
export class SportsParticipationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  banner: any = {
    pagetitle: "Participation",
    bg_image: "assets/images/banner/bnr3.jpg",
    title: "Participation",
  }
}
